import React, {Component, useState} from 'react'
import {Card, CardBody, CardTitle, Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem, Collapse, Col, Row} from 'reactstrap';
import StdTable from '../StdTable'
import StdForm from '../StdForm'
import { reduxForm } from 'redux-form'
import ActionFormModal from '../StdForm/ActionFormModal'
import UserValidator from '../../validators/User'
import GroupValidator from '../../validators/Group'
import StdButton from '../StdButton'
import {Edit3, Trash, UserPlus, ChevronDown, ChevronUp} from 'react-feather';


class CreditsLog extends Component{

    constructor(props) {
	super(props);

    }
  
    componentDidMount(){
	this.props.getGroups()
	this.props.getCredits()
    }

    render(){

	const {groups, createGroup, deleteGroup, addUser, deleteUser, credits,  current_user} = this.props

	const fields_group = [{name: 'name', type: 'text'}, {name: 'credit_id', type: 'select', options: credits.map(c => {return {value: c.id, name: `${c.name} (${c.current_amount})`}})}]
	const fields_user = [{name: 'name', type: 'text'}, {name: 'surname', type: 'text'}, {name: 'email', type: 'text'}, {name: 'password', type: 'password'}, {name: 'user_type', type: 'select', options: [(current_user.info.user_type==='SUPERADMIN' ? {value: 'SUPERADMIN', name: 'SUPERADMIN'} : null), {value: 'ADMIN', name: 'ADMIN'}, {value: 'STANDARD', name: 'STANDARD'}].filter(x => x)}]
	
	
	const AddGroup = (props) =>  <ActionFormModal action_text='Add Group' fields={fields_group} form_name="add_group" trans_prefix="groups" {...props} submitAction={createGroup}  validation={GroupValidator}  />
	const EditGroup = (props) => <ActionFormModal  buttonProps = {{ size: "sm"}} action_text={<Edit3 size='12' />} fields={fields_group} trans_prefix="groups" form_name="edit_group" {...props} submitAction={createGroup}  validation={GroupValidator} />
	const AddUser = (props) => <ActionFormModal  buttonProps = {{ size: "sm"}}  action_text={<UserPlus  size='12' />} fields={fields_user} {...props} trans_prefix="users" form_name="add_user" submitAction={addUser} validation={UserValidator} />
	const EditUser = (props) => <ActionFormModal  buttonProps = {{ size: "sm"}} action_text={<Edit3 size='12' />} fields={fields_user} {...props}  trans_prefix="users" form_name="edit_user" submitAction={addUser} validation={UserValidator} />
	
	const DeleteGroup = ({id}) => <StdButton buttonProps = {{size: "sm",color:"danger"}} action_text={<Trash size='12' />} confirmation={'Sei sicuro?'} buttonAction = {() => deleteGroup(id)} />
	const DeleteUser = ({id}) => <StdButton buttonProps = {{size: "sm",color:"danger"}} action_text={<Trash size='12' />} confirmation={'Sei sicuro?'} buttonAction = {() => deleteUser(id)} />


	const GroupRow = ({g}) => {

	    const [isOpen, setIsOpen] = useState(false);

	    return <li>

		<Row>
		    <Col > <button onClick={() => setIsOpen(!isOpen) } className="content_button">{isOpen ? <ChevronUp /> : <ChevronDown />}{g.name}</button></Col>
		    
		    <Col xs="auto" className="inline_childs">
			<AddUser group_id={g.id} />
			<EditGroup id={g.id} initialValues={g} />
			<DeleteGroup id={g.id}  />
		    </Col>
		</Row>
		<div style={{clear: 'both'}}></div>
		
		<Collapse isOpen={isOpen}>
		    <div className="list-content">
			<StdTable collection={g.users} fields={['email']}  collection_key="id" actions={[EditUser, DeleteUser]}  actions_props={['id']} />
			
		    </div>
		</Collapse>
	    </li>
	}
	

	return (	    
	<Card>
	    <CardBody>
		<CardTitle>Card Title</CardTitle>
		
		<AddGroup />

		<ul className="list-stripped">
		    {groups.map(g => <GroupRow key={g.id}  g={g} />)}
		</ul>
	    </CardBody>
	</Card>
	)
    }
}
export default CreditsLog
